define([
	'internal_util/Util',
	'service/AttributesManager',
	'view/UIView',
	'canvas/InformationCanvas',
	'amdi18n-loader?!identity/nls/IdentityAttributesSelectionView_strings',
	'lib/jquery',
	'lib/bootstrap/tooltip' // doesn't export
], function (
	Util,
	AttributesManager,
	UIView,
	InformationCanvas,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * IdentityAttributesSelectionView class
	 */
	function IdentityAttributesSelectionView(attributesManager, selectionFinishedCallback) {
		var _attributesManager,
			_selectionFinishedCallback = selectionFinishedCallback,
			_view;

		// those attributes can be derived later from DateOfBirth in the backend
		var _ignored_requested_attrs = [ "http://www.skidentity.de/att/Age", "http://www.skidentity.de/att/AgeVerification" ];

		_view = (function () {
				var $view = jQuery(
					"<div id='skIdS_attributes-selection-container'>" +
						"<p class='skIdS_attributes-table-heading'>" + Strings.required_attributes + "</p>" +
						"<div id='skIdS_attributes-selection-required-attributes' class='skIdS_attributes-listing-table'></div>"+
						"<p class='skIdS_attributes-table-heading'>" + Strings.optional_attributes + "</p>" +
						"<div id='skIdS_attributes-selection-optional-attributes' class='skIdS_attributes-listing-table'></div>"+
						"<button id='skIdS_attributes-selection-finished-button' class='btn btn-default'>" + Strings.selection_finished + "</button>" +
					"</div>");

				if (typeof _selectionFinishedCallback === 'function') {
					$view.find('#skIdS_attributes-selection-finished-button')
							.on('click', function () {
								Util.callCallbacks(selectionFinishedCallback, getSelectedAttributes());
							})
							.show();
				} else {
					$view.find('#skIdS_attributes-selection-finished-button').hide();
				}

				return $view;
			})();

		if (attributesManager instanceof AttributesManager) {
			_attributesManager = attributesManager;
		} else {
			throw new Error('invalid attributesManager');
		}

		UIView.call(this);


		// private methods

		function getSupportedAttributes(authenticationOption, requestedAttributes) {
			var supportedAttributes = new Array(),
				i, j;

			if (authenticationOption.attributes() === null || authenticationOption.attributes().length === 0) {
				return requestedAttributes;
			}

			for (i = 0; i < requestedAttributes.length; i++) {
				for (j = 0; j < authenticationOption.attributes().length; j++) {
					if (requestedAttributes[i].name() === authenticationOption.attributes()[j].name()) {
						supportedAttributes.push(requestedAttributes[i]);
					}
				}
			}

			return supportedAttributes;
		}

		function getRequiredAttributes(requestedAttributes) {
			var attributes = new Array(),
				i;

			for (i = 0; i < requestedAttributes.length; i++) {
				if (requestedAttributes[i].isRequired()) {
					attributes.push(requestedAttributes[i]);
				}
			}

			return attributes;
		}

		function getOptionalAttributes(requestedAttributes) {
			var attributes = new Array(),
				i;

			for (i = 0; i < requestedAttributes.length; i++) {
				if (!requestedAttributes[i].isRequired()) {
					attributes.push(requestedAttributes[i]);
				}
			}

			return attributes;
		}

		function getSelectedAttributes() {
			var checkboxes = _view.find("input[type='checkbox']:checked"),
				selectedAttributes = new Array(),
				i;

			for (i = 0; i < checkboxes.length; i++) {
				if (checkboxes[i].name) {
					selectedAttributes.push(checkboxes[i].name);
				}
			}

			return selectedAttributes;
		}

		function removeMissingAttributes(attributes, identity) {
			var availableAttributes = identity.attributeIdentifiers(),
				cleanedAttributes = new Array();

			for (var i = 0; i < attributes.length; i++) {
				if (availableAttributes.indexOf(attributes[i].name()) !== -1) {
					cleanedAttributes.push(attributes[i]);
				}
			}

			return cleanedAttributes;
		}

		function createAttributesTable(attributes, identity, identityAttributes, attributesTable, required, extending) {
			var leftRow,
				rightRow,
				currentRow,
				missing,
				info,
				i, j;

			if (attributes.length === 0) {
				attributesTable.append("<span>" + Strings.no_attribute_requested + "</span>");
				return;
			}

			leftRow = jQuery('<div class="skIdS_attributes-selection-left-row"></div>');
			rightRow = jQuery('<div class="skIdS_attributes-selection-right-row"></div>');

			for (i = 0; i < attributes.length; i++) {
				currentRow = ((i < attributes.length / 2) ? leftRow : rightRow);
				missing = (identity !== null && identity.attributeIdentifiers().indexOf(attributes[i].name()) === -1);

				// show attributes like age and ageverification not as missing
				if (missing && _ignored_requested_attrs.includes(attributes[i].name())) {
					missing = false;
				}

				currentRow.append(
						"<div>" +
							"<div class='skIdS_attributes-selection-attribute-name'>" +
								_attributesManager.name(attributes[i].name()) +
							"</div>" +
							"<div class='skIdS_attributes-selection-attribute-selector'>" +
								"<input type='checkbox' name='" + attributes[i].name() + "' " +
										((!extending && missing) || required ? "disabled" : '') +
										((extending && !missing) || required ? " checked" : '') + "/></div>" +
						"</div>");

				if (!extending) {
					if (missing) {
						currentRow.children().last().children().first()
							.addClass('skIdS_attributes-selection-attribute-missing')
							.tooltip({ html : true })
							.attr('data-original-title', Strings.attribute_not_available);
					} else if (Util.isArray(identityAttributes)) {
						for (j = 0; j < identityAttributes.length; j++) {
							if (attributes[i].name() === identityAttributes[j].name()) {
								// TODO: Use AttributesManager.keyword(name) to resolve name (URI) to keyword
								if (Util.endsWith(attributes[i].name(), 'eIdentifier')) {
									currentRow.children().last().children().first()
										.tooltip({ html : true })
										.attr('data-original-title', Strings.service_provider_specific_identifier);
								} else {
									currentRow.children().last().children().first()
										.tooltip({ html : true })
										.attr('data-original-title', identityAttributes[j].value());
								}
								break;
							}
						}

					}
				}

				if (attributes[i].purpose() !== null) {
					info = jQuery("<div class='skIdS_attributes-selection-attribute-info'></div>");

					info.append(new InformationCanvas().get());

					info.tooltip({ html : true })
						.attr('data-original-title', attributes[i].purpose());

					currentRow.children().last().append(info);
				}
			}

			if (rightRow.children().length < leftRow.children().length) {
				rightRow.children().last().addClass('skIdS_attributes-selection-attribute-less');
			}

			if (!required) {
				rightRow.append(
						"<div class='skIdS_attributes-selection-all-selector'>" +
							"<div class='skIdS_attributes-selection-attribute-name'>" + Strings.select_all + "</div>" +
							"<div class='skIdS_attributes-selection-attribute-selector'>" +
								"<input type='checkbox' /></div>" +
						"</div>");

				rightRow.children().last().find("input[type='checkbox']").on('change', function () {
						var value = jQuery(this).is(':checked');

						leftRow.find("input[type='checkbox']:not(:disabled)").prop('checked', value);
						rightRow.find("input[type='checkbox']:not(:disabled)").prop('checked', value);
					});
			}

			attributesTable.append(leftRow);
			attributesTable.append(rightRow);

			attributesTable.children().children()
				.mouseover(function () {
					jQuery(this).children('div').css('white-space', 'normal');
				})
				.mouseout(function () {
					jQuery(this).children('div').css('white-space', 'nowrap');
				});
		}


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function (authenticationOption, requestedAttributes, identity, identityAttributes, extending) {
			var supportedAttributes,
				requiredAttributes,
				optionalAttributes,
				requiredAttributesTable = _view.find('#skIdS_attributes-selection-required-attributes'),
				optionalAttributesTable = _view.find('#skIdS_attributes-selection-optional-attributes');

			requiredAttributesTable.empty();
			optionalAttributesTable.empty();

			if (Util.isArray(requestedAttributes) && requestedAttributes.length > 0) {
				supportedAttributes = _attributesManager.sortAttributes(
						getSupportedAttributes(authenticationOption, requestedAttributes));

				requiredAttributes = getRequiredAttributes(supportedAttributes);
				optionalAttributes = getOptionalAttributes(supportedAttributes);

				if (identity !== null && !extending) {
					optionalAttributes = removeMissingAttributes(optionalAttributes, identity);
				}

				if (optionalAttributes.length === 0) {
					_view.find('.skIdS_attributes-table-heading').first().text(Strings.attributes);
					_view.find('.skIdS_attributes-table-heading').last().hide();

					createAttributesTable(requiredAttributes, identity, identityAttributes, requiredAttributesTable, true, extending);
				} else {
					_view.find('.skIdS_attributes-table-heading').first().text(Strings.required_attributes);
					_view.find('.skIdS_attributes-table-heading').last().show();

					createAttributesTable(requiredAttributes, identity, identityAttributes, requiredAttributesTable, true, extending);
					createAttributesTable(optionalAttributes, identity, identityAttributes, optionalAttributesTable, false, extending);
				}
			} else {
				// TODO: implement error handling
			}
		};

		this.getSelectedAttributes = function () {
			return getSelectedAttributes();
		};
	};

	IdentityAttributesSelectionView.prototype = Object.create(UIView.prototype);

	return IdentityAttributesSelectionView;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/identity/IdentityAttributesSelectionView.js
// module id = 167
// module chunks = 1